import { render } from "./PasswordForgetMessage.vue?vue&type=template&id=2c10e432"
import script from "./PasswordForgetMessage.vue?vue&type=script&lang=js"
export * from "./PasswordForgetMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__